import "./singleProductpage.modern.css"
import { FaStar, FaShieldAlt, FaTruck, FaUndo, FaCheckCircle } from 'react-icons/fa';
import { HiOutlineShoppingCart } from 'react-icons/hi';
import { useEffect, useState } from "react";
import Loading from "./loading";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function SingleProduct() {
    const isauth = true;
    let [avail, setAvail] = useState(false)
    let [addingToCart, setAddingToCart] = useState(false)
    const [quantity, setQuantity] = useState(1);
    const [activeTab, setActiveTab] = useState('description');
    const [reviews, setReviews] = useState([]); // Real reviews from API
    const [reviewsLoading, setReviewsLoading] = useState(false);
    const [reviewForm, setReviewForm] = useState({
        rating: 0,
        name: '',
        email: '',
        comment: ''
    });
    const [reviewFormErrors, setReviewFormErrors] = useState({});
    const [isSubmittingReview, setIsSubmittingReview] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    let navigate = useNavigate()

    const handleIncrement = () => setQuantity(prev => prev + 1);
    const handleDecrement = () => setQuantity(prev => prev > 1 ? prev - 1 : 1);

    const handleReviewSubmit = async (e) => {
        e.preventDefault();
        
        // Validate form
        const errors = {};
        if (reviewForm.rating === 0) errors.rating = 'Please select a rating';
        if (!reviewForm.name.trim()) errors.name = 'Name is required';
        if (!reviewForm.email.trim()) errors.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(reviewForm.email)) errors.email = 'Email is invalid';
        if (!reviewForm.comment.trim()) errors.comment = 'Review is required';
        
        if (Object.keys(errors).length > 0) {
            setReviewFormErrors(errors);
            return;
        }
        
        setIsSubmittingReview(true);
        setReviewFormErrors({});
        
        try {
            const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
            const response = await fetch(`${apiUrl}/reviews`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    product_id: id,
                    rating: reviewForm.rating,
                    name: reviewForm.name,
                    email: reviewForm.email,
                    comment: reviewForm.comment
                })
            });
            
            const data = await response.json();
            
            if (data.success) {
                setSubmitSuccess(true);
                setReviewForm({ rating: 0, name: '', email: '', comment: '' });
                // Refresh reviews
                fetchReviews();
                // Hide success message after 5 seconds
                setTimeout(() => setSubmitSuccess(false), 5000);
            } else {
                setReviewFormErrors({ submit: data.message || 'Failed to submit review' });
            }
        } catch (error) {
            console.error('Error submitting review:', error);
            setReviewFormErrors({ submit: 'Failed to submit review. Please try again.' });
        } finally {
            setIsSubmittingReview(false);
        }
    };

    // Calculate review statistics (ONLY if reviews exist)
    const getReviewStats = () => {
        if (reviews.length === 0) return null;
        
        const total = reviews.length;
        const sum = reviews.reduce((acc, r) => acc + r.rating, 0);
        const average = sum / total;
        
        const breakdown = {
            5: reviews.filter(r => r.rating === 5).length,
            4: reviews.filter(r => r.rating === 4).length,
            3: reviews.filter(r => r.rating === 3).length,
            2: reviews.filter(r => r.rating === 2).length,
            1: reviews.filter(r => r.rating === 1).length,
        };
        
        return { total, average, breakdown };
    };

    const stats = getReviewStats();

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    };

    const { id } = useParams()
    const [obj, setObj] = useState({
        id: null,
        name: "",
        vendor_name: "",
        category_name: "",
        price: "0",
        local_path: "",
        description: "",
        stock_quantity: 0,
    })
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
        fetch(`${apiUrl}/products/${id}`)
            .then((res) => res.json())
            .then((response) => {
                console.log('Product data:', response);
                setLoading(false)
                if (response.success && response.data) {
                    setObj(response.data)
                }
            })
            .catch((error) => {
                console.error('Error fetching product:', error);
                setLoading(false);
            })
        
        // Fetch reviews for this product
        fetchReviews();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const fetchReviews = async () => {
        setReviewsLoading(true);
        try {
            const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
            const response = await fetch(`${apiUrl}/reviews/product/${id}`);
            const data = await response.json();
            if (data.success && data.data) {
                setReviews(data.data);
            }
        } catch (error) {
            console.error('Error fetching reviews:', error);
        } finally {
            setReviewsLoading(false);
        }
    };

    async function addToCart() {
        if (!isauth) {
            console.log("❌ User not authenticated");
            return;
        }

        setAddingToCart(true);
        console.log("🛒 Adding to cart:", { productId: obj.id, quantity });

        try {
            // Get current cart from localStorage
            const cart = JSON.parse(localStorage.getItem('cart') || '[]');
            
            // Check if product already in cart
            const existingItemIndex = cart.findIndex(item => item.id === obj.id);
            
            if (existingItemIndex >= 0) {
                // Update quantity
                cart[existingItemIndex].quantity += quantity;
                setAvail(true);
            } else {
                // Add new item
                const cartItem = {
                    id: obj.id,
                    name: obj.name,
                    price: obj.price,
                    category_name: obj.category_name,
                    vendor_name: obj.vendor_name,
                    image_url: getImageUrl(obj),
                    quantity: quantity
                };
                cart.push(cartItem);
                setAvail(false);
            }
            
            // Save to localStorage
            localStorage.setItem('cart', JSON.stringify(cart));
            
            // Trigger cart update event
            window.dispatchEvent(new Event('cartUpdated'));
            
            console.log("✅ Added to cart successfully");
        } catch (error) {
            console.error('❌ Error adding to cart:', error);
        } finally {
            setAddingToCart(false);
        }
    }

    const getImageUrl = (product) => {
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
        const baseUrl = apiUrl.replace('/api', '');
        if (product.images && Array.isArray(product.images) && product.images.length > 0) {
            const primaryImage = product.images.find(img => img.is_primary) || product.images[0];
            if (primaryImage && primaryImage.local_path) {
                if (primaryImage.local_path.startsWith('/uploads/')) return `${baseUrl}${primaryImage.local_path}`;
                return `${baseUrl}/api/images/${primaryImage.local_path}`;
            }
        }
        if (product.local_path) {
            if (product.local_path.startsWith('/uploads/')) return `${baseUrl}${product.local_path}`;
            return `${baseUrl}/api/images/${product.local_path}`;
        }
        return "/images/placeholder.jpg";
    };

    const isLowStock = obj.stock_quantity > 0 && obj.stock_quantity < 10;

    return (
        <>
            {loading ? <Loading /> :
                <div className="modern-product-detail">
                    {/* Breadcrumbs */}
                    <div className="product-breadcrumbs">
                        <span onClick={() => navigate('/')}>Home</span>
                        <span>›</span>
                        <span onClick={() => navigate('/products')}>Products</span>
                        <span>›</span>
                        <span>{obj.category_name}</span>
                    </div>

                    {/* Product Container */}
                    <div className="product-container">
                        {/* Image Section */}
                        <div className="product-images">
                            <div className="product-main-image">
                                <img src={getImageUrl(obj)} alt={obj.name} />
                            </div>
                        </div>

                        {/* Product Info */}
                        <div className="product-info">
                            {obj.vendor_name && <p className="product-brand">{obj.vendor_name}</p>}
                            <h1 className="product-title">{obj.name}</h1>

                            <div className="product-price">${parseFloat(obj.price).toFixed(2)}</div>

                            {/* Stock Indicator - Subtle */}
                            {obj.stock_quantity > 0 ? (
                                <div className={`product-stock ${isLowStock ? 'low-stock' : 'in-stock'}`}>
                                    ● {isLowStock ? `Only ${obj.stock_quantity} left in stock` : `In stock`}
                                </div>
                            ) : (
                                <div className="product-stock out-of-stock">
                                    ● Out of Stock
                                </div>
                            )}

                            {/* Quantity Selector */}
                            <div className="quantity-section">
                                <p className="quantity-label">Quantity:</p>
                                <div className="quantity-selector">
                                    <button onClick={handleDecrement} className="quantity-btn">−</button>
                                    <span className="quantity-value">{quantity}</span>
                                    <button onClick={handleIncrement} className="quantity-btn">+</button>
                                </div>
                            </div>

                            {/* CTA Section */}
                            <div className="cta-section">
                                <button 
                                    onClick={addToCart} 
                                    className="add-to-cart-btn" 
                                    type="button" 
                                    data-bs-toggle="modal" 
                                    data-bs-target="#exampleModal" 
                                    disabled={addingToCart || obj.stock_quantity === 0}
                                >
                                    <HiOutlineShoppingCart />
                                    {addingToCart ? 'Adding...' : obj.stock_quantity === 0 ? 'Out of Stock' : 'Add to Cart'}
                                </button>
                                <button className="buy-now-btn" disabled={obj.stock_quantity === 0}>
                                    Buy Now
                                </button>
                            </div>

                            {/* Trust Signals */}
                            <div className="trust-signals">
                                <div className="trust-item">
                                    <FaUndo />
                                    30-day returns
                                </div>
                                <div className="trust-item">
                                    <FaTruck />
                                    Ships within 24 hours
                                </div>
                            </div>

                            {/* Trust Badges */}
                            <div className="trust-badges">
                                <div className="trust-badge">
                                    <FaShieldAlt />
                                    Secure checkout
                                </div>
                                <div className="trust-badge">
                                    <FaCheckCircle />
                                    100% Authentic
                                </div>
                                <div className="trust-badge">
                                    <FaTruck />
                                    Fast shipping
                                </div>
                            </div>

                            {/* Modal */}
                            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-body">
                                            <h3>{isauth ? (!avail ? obj.name + " Added to Cart" : "Item already added") : "You have to Login first"}</h3>
                                        </div>
                                        <div className="modal-footer">
                                            <button onClick={() => { isauth ? navigate("/cart") : navigate("/login") }} type="button" data-bs-dismiss="modal" className="btn btn-primary">
                                                {isauth ? "Go to cart" : "Login"}
                                            </button>
                                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Product Tabs */}
                    <div className="product-tabs">
                        <div className="tabs-header">
                            <button 
                                className={`tab-button ${activeTab === 'description' ? 'active' : ''}`}
                                onClick={() => setActiveTab('description')}
                            >
                                Description
                            </button>
                            <button 
                                className={`tab-button ${activeTab === 'reviews' ? 'active' : ''}`}
                                onClick={() => setActiveTab('reviews')}
                            >
                                Reviews
                            </button>
                        </div>

                        <div className="tab-content">
                            <div className={`tab-panel ${activeTab === 'description' ? 'active' : ''}`}>
                                <p className="description-text">
                                    {obj.description || "This premium nail product delivers professional-quality results. Perfect for salon use or at-home application. Long-lasting formula with vibrant color payoff."}
                                </p>
                            </div>

                            <div className={`tab-panel ${activeTab === 'reviews' ? 'active' : ''}`}>
                                <div className="reviews-section">
                                    <h2 className="reviews-main-title">Customer Reviews</h2>
                                    
                                    {reviewsLoading ? (
                                        <div className="reviews-loading">Loading reviews...</div>
                                    ) : reviews.length === 0 ? (
                                        /* EMPTY STATE - NO FAKE DATA */
                                        <div className="reviews-empty-state">
                                            <div className="empty-state-card">
                                                <div className="empty-state-icon">
                                                    <FaStar size={48} color="#E8E8E8" />
                                                </div>
                                                <h3 className="empty-state-title">No reviews yet</h3>
                                                <p className="empty-state-text">
                                                    Be the first to review this product.<br />
                                                    Your feedback helps other salon professionals choose confidently.
                                                </p>
                                                <button 
                                                    className="empty-state-cta"
                                                    onClick={() => document.getElementById('review-form').scrollIntoView({ behavior: 'smooth' })}
                                                >
                                                    Write the first review
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        /* HAS REVIEWS - SHOW REAL DATA ONLY */
                                        <div className="reviews-with-data">
                                            <div className="reviews-layout">
                                                {/* Rating Summary */}
                                                <div className="rating-summary-card">
                                                    <div className="average-rating-display">
                                                        <div className="average-number">{stats.average.toFixed(1)}</div>
                                                        <div className="average-stars">
                                                            {[1, 2, 3, 4, 5].map((star) => (
                                                                <FaStar
                                                                    key={star}
                                                                    color={star <= Math.round(stats.average) ? "#ffc107" : "#e4e5e9"}
                                                                    size={20}
                                                                />
                                                            ))}
                                                        </div>
                                                        <div className="review-count-text">{stats.total} {stats.total === 1 ? 'review' : 'reviews'}</div>
                                                    </div>
                                                    
                                                    <div className="rating-breakdown">
                                                        {[5, 4, 3, 2, 1].map((rating) => (
                                                            <div key={rating} className="breakdown-row">
                                                                <span className="breakdown-label">{rating} star</span>
                                                                <div className="breakdown-bar">
                                                                    <div 
                                                                        className="breakdown-fill"
                                                                        style={{ width: `${(stats.breakdown[rating] / stats.total) * 100}%` }}
                                                                    ></div>
                                                                </div>
                                                                <span className="breakdown-count">{stats.breakdown[rating]}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                                
                                                {/* Reviews List */}
                                                <div className="reviews-list-container">
                                                    <div className="reviews-list-header">
                                                        <button 
                                                            className="write-review-btn-inline"
                                                            onClick={() => document.getElementById('review-form').scrollIntoView({ behavior: 'smooth' })}
                                                        >
                                                            Write a review
                                                        </button>
                                                    </div>
                                                    
                                                    <div className="reviews-list">
                                                        {reviews.map((review) => (
                                                            <div key={review.id} className="review-card">
                                                                <div className="review-header">
                                                                    <div className="review-stars">
                                                                        {[1, 2, 3, 4, 5].map((star) => (
                                                                            <FaStar
                                                                                key={star}
                                                                                color={star <= review.rating ? "#ffc107" : "#e4e5e9"}
                                                                                size={16}
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                    <div className="review-meta">
                                                                        <span className="review-author">{review.name}</span>
                                                                        {review.verified && <span className="verified-badge">Verified Purchase</span>}
                                                                        <span className="review-date">{formatDate(review.created_at)}</span>
                                                                    </div>
                                                                </div>
                                                                <p className="review-text">{review.comment}</p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    
                                    {/* Review Form - Always Available */}
                                    <div className="review-form-container" id="review-form">
                                        <h3 className="review-form-title">Write a Review</h3>
                                        
                                        {submitSuccess && (
                                            <div className="submit-success-message">
                                                <FaCheckCircle /> Thanks! Your review was submitted successfully.
                                            </div>
                                        )}
                                        
                                        <form onSubmit={handleReviewSubmit} className="review-form">
                                            <div className="form-group">
                                                <label>Rating *</label>
                                                <div className="rating-input">
                                                    {[1, 2, 3, 4, 5].map((star) => (
                                                        <FaStar
                                                            key={star}
                                                            className="rating-star"
                                                            color={star <= reviewForm.rating ? "#ffc107" : "#e4e5e9"}
                                                            onClick={() => {
                                                                setReviewForm({...reviewForm, rating: star});
                                                                setReviewFormErrors({...reviewFormErrors, rating: ''});
                                                            }}
                                                            style={{ cursor: 'pointer', fontSize: '28px' }}
                                                        />
                                                    ))}
                                                </div>
                                                {reviewFormErrors.rating && <span className="error-text">{reviewFormErrors.rating}</span>}
                                            </div>
                                            
                                            <div className="form-row">
                                                <div className="form-group">
                                                    <label>Name *</label>
                                                    <input
                                                        type="text"
                                                        value={reviewForm.name}
                                                        onChange={(e) => {
                                                            setReviewForm({...reviewForm, name: e.target.value});
                                                            setReviewFormErrors({...reviewFormErrors, name: ''});
                                                        }}
                                                        className={`form-input ${reviewFormErrors.name ? 'error' : ''}`}
                                                        placeholder="Your name"
                                                    />
                                                    {reviewFormErrors.name && <span className="error-text">{reviewFormErrors.name}</span>}
                                                </div>
                                                
                                                <div className="form-group">
                                                    <label>Email *</label>
                                                    <input
                                                        type="email"
                                                        value={reviewForm.email}
                                                        onChange={(e) => {
                                                            setReviewForm({...reviewForm, email: e.target.value});
                                                            setReviewFormErrors({...reviewFormErrors, email: ''});
                                                        }}
                                                        className={`form-input ${reviewFormErrors.email ? 'error' : ''}`}
                                                        placeholder="your@email.com"
                                                    />
                                                    <span className="field-note">Email will not be shown publicly</span>
                                                    {reviewFormErrors.email && <span className="error-text">{reviewFormErrors.email}</span>}
                                                </div>
                                            </div>
                                            
                                            <div className="form-group">
                                                <label>Your Review *</label>
                                                <textarea
                                                    value={reviewForm.comment}
                                                    onChange={(e) => {
                                                        setReviewForm({...reviewForm, comment: e.target.value});
                                                        setReviewFormErrors({...reviewFormErrors, comment: ''});
                                                    }}
                                                    rows="5"
                                                    className={`form-textarea ${reviewFormErrors.comment ? 'error' : ''}`}
                                                    placeholder="Share your experience with this product..."
                                                    maxLength="1000"
                                                />
                                                <div className="textarea-footer">
                                                    <span className="char-counter">{reviewForm.comment.length}/1000</span>
                                                </div>
                                                {reviewFormErrors.comment && <span className="error-text">{reviewFormErrors.comment}</span>}
                                            </div>
                                            
                                            {reviewFormErrors.submit && (
                                                <div className="submit-error-message">{reviewFormErrors.submit}</div>
                                            )}
                                            
                                            <button 
                                                type="submit" 
                                                className="submit-review-btn"
                                                disabled={isSubmittingReview}
                                            >
                                                {isSubmittingReview ? 'Submitting...' : 'Submit Review'}
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Sticky CTA - Mobile */}
                    <div className="sticky-cta">
                        <div className="sticky-cta-content">
                            <div className="sticky-cta-info">
                                <div className="sticky-cta-price">${parseFloat(obj.price).toFixed(2)}</div>
                            </div>
                            <button className="sticky-cta-btn" onClick={addToCart} disabled={obj.stock_quantity === 0}>
                                Add to Cart
                            </button>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default SingleProduct
